module.exports = __webpack_public_path__ + "img/not-content.710378d8.svg";